@if(!isLoaded) { <div>Lade Website...</div> }
@else {
    <router-outlet></router-outlet>
    @if(isAdminPage && showAdminPanel && loggedIn()) {
    <div class="admin-panel admin-theme">
        <div class="admin-panel-container">
            <div class="admin-panel-group">
                <app-toggle-edit-mode></app-toggle-edit-mode>
                <app-save></app-save>
                <app-website-config></app-website-config>
            </div>
            <div class="admin-panel-group">
                <app-userinfo></app-userinfo>        
                <app-userinfo-faq></app-userinfo-faq>
            </div>
            <div class="admin-panel-group">
                <app-logout></app-logout>
                <app-payment-info></app-payment-info>
            </div>

        </div>
    </div>
    } @else if(!isAdminPage) {
        <app-notification-speical-opening-hours></app-notification-speical-opening-hours> 
    }
}